export const perfilHistoricoMap = {
    AUDITOR: 'Auditor',
    GERENTE: 'Gerente',
    ENCARREGADO: 'Encarregado',
    VISITANTE: 'Visitante',
    ADMIN_SISTEMA: 'Sistema'
}